<template>
  <DefaultLayout>
    <div ref="topdiv">
      <img v-lazy="getPhoto" class="img-fluid" />      
      <div class="text-center">
        <br />
        <h4>{{ getScenario.start_title }}</h4>
      </div>
      <span v-html="getScenario.start_description" />
      <br />
      <br />
      <SuggestionBoxInfo/>
      <div class="text-center" v-if="$store.getters.getIsFacilitator || ($store.getters.getThisPlayer && $store.getters.getThisPlayer.paused) || $store.getters.getCurrentCaseNumberForPlayers > 0">
        <base-button type="success" v-on:click="start()">{{
          $t("start")
        }}</base-button>
      </div>
      <SuggestionBox :isClassicGame="true"/>
    </div>
  </DefaultLayout>
</template>

<script>
import SuggestionBox from "@/components/SuggestionBox.vue";
import { mapGetters } from "vuex";
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import {
  updateGameCurrentCaseNumberForPlayers,
} from "../services/APIService";
import SuggestionBoxInfo from "@/components/SuggestionBoxInfo.vue";
import { convertPhotoToAmazonURL } from "@/services/utils";

export default {
  components: { DefaultLayout, SuggestionBoxInfo, SuggestionBox },
  watch: {
    getCurrentCaseNumberForPlayers: {
      handler(newData, oldData) {
        if (this.$store.state.main.playerIsObserver && newData > 0) {
          this.gotoCase(newData)
        }

        if (newData === 1) {
          // We should move to the first case
          this.gotoFirstCase();
        }
      },      
    }
  },
  data: function () {
    return {};
  },
  async created() {
    this.$store.commit({
      type: "setCurrentCaseNumber",
      currentCaseNumber: 0,
    });

    this.$store.dispatch("updateEverything");

    this.$store.dispatch("connectNotification");

    if (this.$store.state.main.playerIsObserver && this.$store.getters.getCurrentCaseNumberForPlayers > 0) {
      this.gotoCase(this.$store.getters.getCurrentCaseNumberForPlayers)
    }
  },
  computed: {
    ...mapGetters([
      "getCurrentCaseNumberForPlayers",
    ]),    
    getPhoto() {
      if (this.getScenario.start_photo) {
        return convertPhotoToAmazonURL(this.getScenario.start_photo);
      } else {
        return "/placeholder.png";
      }
    },
    getScenario() {
      return this.$store.getters.getScenarioInCurrentLocale;
    },
  },
  methods: {
    async start() {
      if (!this.$store.state.main.playerIsObserver && this.$store.getters.getIsFacilitator && (!this.$store.state.main.game.currentCaseNumberForPlayers || this.$store.state.main.game.currentCaseNumberForPlayers === 0)) {
        await updateGameCurrentCaseNumberForPlayers(this.$store.state.main.game.id, this.$store.state.main.game.gameCode, 1);
        await this.$store.dispatch("updateGame");
        // force update and wait for it, otherwise we will have old data for a while in the first case and "previous case" button will be shown briefly        
        // We will move automatically to first case when game is updated
      } else {
        this.gotoFirstCase();
      }
    },
    async gotoFirstCase() {
      if (this.$router.currentRoute.path !== "/game/1") {
        await this.$router.push("/game/1");
      }
    },
    async gotoCase(caseNumber) {
      await this.$router.push("/game/" + caseNumber);
    }    
  },
};
</script>

<i18n>
{
  "en": {
    "start": "Let's go!"
  },
  "fi": {
    "start": "Aloitetaan!"
  },
 "sv": {
    "start": "Då börjar vi!"
  },
 "de": {
    "start": "Los geht's!"
  },
  "ko": {
      "start": "출발!"
  }
}
</i18n>
